import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg, fmt } from "../lib/api";
import PrintDialog from "../components/PrintDialog";
import GradeEditor from "../components/GradeEditor";
import { useAuth } from "../lib/auth";

export default function BarcodeDetail() {
  const { barcode } = useParams();
  const { can } = useAuth();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [print, setPrint] = useState(null);
  const reload = () => api.get(`/barcode/${barcode}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e)));
  useEffect(() => { reload(); }, [barcode]); // eslint-disable-line react-hooks/exhaustive-deps
  if (err) return <div className="alert error" data-testid="barcode-detail-error">{err}</div>;
  if (!d) return <div className="dashboard-loading">Memuat...</div>;
  const b = d.barcode;
  return (
    <div className="card" data-testid="barcode-detail-page">
      <h3>HASIL SCAN / 扫码结果: <span data-testid="barcode-detail-id">{b.barcode_id}</span></h3>
      <div className="review-grid">
        {[["Kode Material", b.material_code], ["Kategori", b.kategori], ["Spesifikasi", b.spesifikasi], ["Dimensi × Panjang", `${b.dimensi} × ${b.panjang}`], ["Grade / Tebal", <span>{can("MASTER_EDIT") ? <GradeEditor row={b} onSaved={reload} /> : (b.grade || "")} / {b.tebal || ""}</span>], ["Satuan", b.satuan], ["Kg/Unit", `${fmt(b.kg_per_unit)} (${b.tonase_source})`], ["Supplier / Proyek", `${b.supplier || "-"} / ${b.proyek || "-"}`], ["Registrasi", String(b.reg_date).slice(0, 19)], ["Total Stok", `${fmt(d.total_qty)} ${b.satuan}`]].map(([k, v]) => <div className="review-item" key={k}><span>{k}</span><b>{v}</b></div>)}
      </div>
      <table className="data-table mt"><thead><tr><th>Area</th><th>Qty Awal</th><th>Qty</th><th>Menunggu Verif.</th><th></th></tr></thead><tbody>
        {d.areas.map((a) => <tr key={a.area}><td><b>{a.area}</b></td><td>{fmt(a.qty_awal)}</td><td><b data-testid={`barcode-area-qty-${a.area}`}>{fmt(a.qty)}</b></td><td>{fmt(a.reserved)}</td><td><button className="btn-mini" onClick={() => setPrint({ barcodeId: b.barcode_id, area: a.area, stock: a.qty, satuan: b.satuan })} data-testid={`barcode-reprint-${a.area}`}>Cetak Ulang</button></td></tr>)}
      </tbody></table>
      <div className="receiving-divider">Riwayat (30 terakhir)</div>
      <div className="table-wrap short"><table className="data-table"><thead><tr><th>Tanggal</th><th>Aktivitas</th><th>Area</th><th>Mutasi</th><th>Sebelum→Sesudah</th><th>Operator</th></tr></thead><tbody>
        {d.history.map((h, i) => <tr key={i}><td>{String(h.tanggal).slice(0, 10)}</td><td>{h.aktivitas}</td><td>{h.area}</td><td>{fmt(h.delta)}</td><td>{fmt(h.stock_before)}→{fmt(h.stock_after)}</td><td>{h.operator}</td></tr>)}
      </tbody></table></div>
      {print && <PrintDialog {...print} onClose={() => setPrint(null)} />}
    </div>
  );
}
